module.exports = __webpack_public_path__ + "static/media/oh_pack1_sample001_0009.e23f8176.png";